import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useContacts(): RootState['contacts'] {
    const contacts = useSelector<RootState, RootState['contacts']>(({ contacts }) => contacts)

    return contacts
}
